var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMangueraDeshabilitada(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1924 0.357155L1.77933 7.08376C0.639589 7.65363 0.00056076 8.81796 0.00056076 10.0924V19.8355C0.00056076 21.7267 1.5256 21.6656 2.28813 21.3986L6.72717 19.5625C10.0905 18.1698 13.376 14.4715 13.376 10.0924C13.376 9.67855 13.1992 9.29177 13.0626 8.92601L18.1708 6.37431C19.8327 5.54337 20.5161 3.52328 19.6851 1.86139C18.8542 0.201181 16.8576 -0.477154 15.1924 0.357155Z",
    fill: "#C6C6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMangueraDeshabilitada);
export default __webpack_public_path__ + "static/media/manguera_deshabilitada.227722159b8eeb9ce5e32afc0d01b3d9.svg";
export { ForwardRef as ReactComponent };